/* ChazaCo — Sticky TOC de la pagina de producto.
   "shipping" y "related" arrancan visibles porque su contenido depende de
   render condicional (disclosures) o de un fetch async (recomendaciones);
   este script los oculta si el objetivo termina vacio, y observa el
   contenedor de "related" porque se rellena despues del load inicial. */
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function init() {
    var toc = document.getElementById('ChzToc');
    if (!toc) return;

    var links = Array.prototype.slice.call(toc.querySelectorAll('.chz-toc__link'));
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function isEmpty(el) {
      if (!el) return true;
      return el.textContent.trim().length === 0 && el.children.length === 0;
    }

    function syncLink(link) {
      var item = link.closest('.chz-toc__item');
      if (!item || !item.hasAttribute('data-chz-toc-dynamic')) return;
      var target = document.getElementById(link.getAttribute('href').slice(1));
      item.hidden = isEmpty(target);
    }

    function syncAll() {
      links.forEach(syncLink);
      var anyVisible = toc.querySelectorAll('.chz-toc__item:not([hidden])').length > 0;
      toc.hidden = !anyVisible;
    }

    syncAll();

    var relatedTarget = document.getElementById('chz-toc-related');
    var relatedObserver = null;
    if (relatedTarget && 'MutationObserver' in window) {
      relatedObserver = new MutationObserver(syncAll);
      relatedObserver.observe(relatedTarget, { childList: true, subtree: true });
    }

    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = document.getElementById(link.getAttribute('href').slice(1));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
        history.replaceState(null, '', link.getAttribute('href'));
      });
    });

    if ('IntersectionObserver' in window) {
      var sections = links
        .map(function (link) { return document.getElementById(link.getAttribute('href').slice(1)); })
        .filter(Boolean);

      var activeObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var link = toc.querySelector('.chz-toc__link[href="#' + entry.target.id + '"]');
            if (link) link.classList.toggle('is-active', entry.isIntersecting);
          });
        },
        { rootMargin: '-40% 0px -50% 0px' }
      );
      sections.forEach(function (section) { activeObserver.observe(section); });
    }

    /* Theme editor re-renders sections in place without a full page reload;
       without this, editing the product page repeatedly in the customizer
       piles up observers that keep watching a detached #ChzToc. */
    document.addEventListener('shopify:section:unload', function (e) {
      if (!e.target || !e.target.contains(toc)) return;
      if (relatedObserver) relatedObserver.disconnect();
      if (activeObserver) activeObserver.disconnect();
    });
  }

  ready(init);
})();
